import { FieldMap } from '../map/FieldMap.tsx';
import s from './MapKit.module.css';

// The Field Survey style on the Kyoto sample extract (T-PKG-03). The file is local and gitignored:
// `make map-sample` fetches it from R2 dev into web/public/map/samples/.
const KYOTO: [[number, number], [number, number]] = [
  [135.7588, 34.985],
  [135.7865, 35.0062],
];

export function MapKit() {
  return (
    <main className={s.page}>
      <FieldMap tiles="/map/samples/sample-kyoto.pmtiles" bounds={KYOTO} label="Map of central Kyoto" />
    </main>
  );
}
